import { SUPERANNUATION } from '@/core/field-names';
import { SuperannuationFieldErrors } from '@/core/validation/field-errors';
import { isTFNValid } from '@/core/validation/common/tfn-declaration';
/**
 * @param field {Object}
 * @param field.name {String}
 * @param field.value {Any}
 * @returns {Promise<string>}
 */
export async function validateSuperannuation(field) {
  switch (field.name) {
    case SUPERANNUATION.OPTION:
      return validateHasSuperfundOption(field);
    case SUPERANNUATION.TYPE:
      return validateSuperType(field);
    case SUPERANNUATION.NAME:
      return validateUserName(field);
    case SUPERANNUATION.TFN:
      return validateTFN(field);
    case SUPERANNUATION.FUND_NAME:
      return validateFundName(field);
    case SUPERANNUATION.MEMBER_NUMBER:
      return validateMemberNumber(field);
    case SUPERANNUATION.DECLARATION:
      return validateDeclaration(field);
    default:
      return '';
  }
}

function isVisibleAndNullValue(field) {
  return field.appliedRules.visible && !field.value;
}

function isEmptyObject(obj) {
  if (!obj) {
    return;
  }
  return Object.keys(obj).length === 0;
}

function isEmptyPropertiesObject(obj) {
  if (!obj) {
    return;
  }
  return (
    !obj?.ABN && !obj?.ProductName && !obj?.USI && !obj?.description && !obj?.id
  );
}

export function validateHasSuperfundOption(field) {
  if (!field.value) {
    return SuperannuationFieldErrors.EmptyOption;
  }
  return '';
}

export function validateSuperType(field) {
  if (isVisibleAndNullValue(field)) {
    return SuperannuationFieldErrors.EmptyOption;
  }
  return '';
}

export function validateUserName(field) {
  if (isVisibleAndNullValue(field)) {
    return SuperannuationFieldErrors.EmptyName;
  }
  return '';
}

export function validateTFN(field) {
  if (isVisibleAndNullValue(field)) {
    return SuperannuationFieldErrors.EmptyTFN;
  }

  if (field.appliedRules.visible && field.value) {
    const isAlphaNumeric = /^[0-9a-zA-Z]+$/;
    if (!isAlphaNumeric.test(field.value) || field.value.length !== 9) {
      return SuperannuationFieldErrors.InvalidTFN;
    }
  }

  if (field.appliedRules.visible && isNaN(field.value)) {
    return SuperannuationFieldErrors.UnknownInput;
  }

  if (field.appliedRules.visible && !isTFNValid(field.value)) {
    return SuperannuationFieldErrors.InvalidTFN;
  }

  return '';
}

export function validateFundName(field) {
  if (isVisibleAndNullValue(field) && !field.valueObj) {
    return SuperannuationFieldErrors.EmptyFundName;
  }

  // when no value assigned
  if (
    isVisibleAndNullValue(field) &&
    (isEmptyObject(field.superfundAUValue) ||
      isEmptyPropertiesObject(field.superfundAUValue))
  ) {
    return SuperannuationFieldErrors.EmptyFundName;
  }

  if (
    isVisibleAndNullValue(field) &&
    (isEmptyObject(field.valueObj) || isEmptyPropertiesObject(field.valueObj))
  ) {
    return SuperannuationFieldErrors.EmptyFundName;
  }

  // when nothing is selected from the dropdown
  if (
    field.appliedRules.visible &&
    field.value &&
    (isEmptyObject(field.superfundAUValue) ||
      isEmptyPropertiesObject(field.superfundAUValue)) &&
    (isEmptyObject(field.valueObj) || isEmptyPropertiesObject(field.valueObj))
  ) {
    return SuperannuationFieldErrors.InvalidFundName;
  }
  return '';
}

export function validateMemberNumber(field) {
  const isAlphaNumeric = /^[0-9a-zA-Z]+$/;
  if (isVisibleAndNullValue(field)) {
    return SuperannuationFieldErrors.EmptyMemberNumber;
  }

  if (field.appliedRules.visible && !isAlphaNumeric.test(field.value)) {
    return SuperannuationFieldErrors.UnknownInput;
  }
  return '';
}

export function validateDeclaration(field) {
  if (isVisibleAndNullValue(field)) {
    return SuperannuationFieldErrors.EmptyDeclaration;
  }

  if (field.appliedRules.visible && typeof field.value !== 'boolean') {
    return SuperannuationFieldErrors.UnknownInput;
  }
  return '';
}
